import { Component } from '@angular/core';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { BuyerConfigService } from '../../../services/buyer-config/buyer.config.service';
import { SurveyMetaDataService } from '../../../../shared/services/survey-meta-data/survey-meta-data.service';

@Component({
  selector: 'ps-ui-processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.css', '../header-dropdown.scss'],
})
export class ProcessingComponent {
  showLabel: boolean = true;
  manualProcessing: boolean = false;

  constructor(
    private _authService: AuthService,
    private _buyerConfigService: BuyerConfigService,
    private _surveyMetaDataService: SurveyMetaDataService,
    private _toastr: ToasterService
  ) {
    this.manualProcessing =
      this._authService.buyerConfig?.enableManualProcessing || false;
    if (this.manualProcessing) {
      this._surveyMetaDataService.setSurveyProcessing({
        manual: this.manualProcessing,
      });
    }
  }

  get label() {
    return this.manualProcessing ? 'Manual' : 'Real time';
  }

  labelToggle() {
    this.showLabel = !this.showLabel;
  }

  changed(isManualProcessing: boolean) {
    const { cmp: id } = this._authService.user!;
    this._buyerConfigService
      .updateBuyerConfig(this._authService.buyerConfig!._id, {
        id,
        config: 'enableManualProcessing',
        enable: isManualProcessing,
      })
      .subscribe(
        () => {
          this._authService.buyerConfig!.enableManualProcessing =
            isManualProcessing;
          this._authService.saveBuyerConfig();
          this.manualProcessing = isManualProcessing;
          this._surveyMetaDataService.setSurveyProcessing({
            manual: isManualProcessing,
          });
          this._toastr.success('Processing setting updated successfully');
        },
        (err) => {
          this._toastr.error(err.error.msg);
        }
      );
  }

  save() {
    this._surveyMetaDataService.saveSurvey();
  }
}
